import React from 'react';

interface MFooterProps {
  children: React.ReactNode;
}

const MFooter: React.FC<MFooterProps> = ({children}) => {
  return (
    <React.Fragment>
      <div className='mjp-modal-footer'>
        {children}
      </div>
    </React.Fragment>
  )
}

export default MFooter;